/**
 * Mantine's default modal z-index, and the base `useModalsStack` registers from
 * (the Nth open registered modal paints at BASE + N).
 */
export const MANTINE_MODAL_BASE_Z_INDEX = 200;

/**
 * z-index for a ResponsiveModal that is NOT registered with the global modal stack
 * (no `globalModalId`) but renders while one exists — e.g. an invoice opened from
 * local state inside the company detail modal.
 *
 * Without this it keeps Mantine's default (BASE) while every registered modal sits
 * at BASE + n, so it opens BEHIND its own parent (main-12 "modal appears behind
 * others"). Placing it above every currently-open registered modal makes "opened
 * most recently from inside" mean "on top".
 *
 * Returns `undefined` when there is no stack to compete with (leave Mantine's
 * default alone) or the modal is registered (the stack assigns its own).
 */
export function unregisteredModalZIndex(
  isRegistered: boolean,
  openState: Record<string, boolean> | undefined
): number | undefined {
  if (isRegistered || !openState) return undefined;
  const openCount = Object.values(openState).filter(Boolean).length;
  return MANTINE_MODAL_BASE_Z_INDEX + openCount + 1;
}
